import React from "react";
import Homepage from "./homepage";

const Pages = () => {
  return (
    <>
      <Homepage />
    </>
  );
};

export default Pages;
